import { CloseOutlined, EyeOutlined } from "@ant-design/icons";
import { Popconfirm, Switch, Tooltip, message } from "antd";
import React from "react";
import styles from "./customers.modules.css";
export const customersConstants = (deleteCustomer, handleViewCustomer, editRow, adminRole, handleActiveStatus) => {
  const handleView = async (customer) => {
    try {
      // Ensure selection is updated before opening the view (handles async state/dispatch)
      await editRow(customer.id);
      handleViewCustomer();
    } catch (e) {
      // Keep the view closed and inform the user
      message.error("Failed to load customer details. Please try again.");
      // Optionally log the error for debugging
      // console.error(e);
    }
  };
  return [
    {
      title: "Name",
      width: "30%",
      render: (rowData, index) => {
        return <p>{rowData.name}</p>;
      },
    },
    {
      title: "Email",
      width: "30%",
      render: (rowData, index) => {
        return <p>{rowData.email}</p>;
      },
    },
    {
      title: "Role",
      width: "20%",
      render: (rowData, index) => {
        return <p>{rowData.role}</p>;
      },
    },
    {
      title: "Active",
      width: "10%",
      render: (rowData, index) => {
        return <Switch onChange={(e) => handleActiveStatus(rowData.id, e)} checked={rowData.active} className={styles.switch} />;
      },
    },
    {
      title: "",
      width: "10%",
      render: (rowData, index) => {
        return (
          <div>
            <Tooltip title="View">
              <EyeOutlined style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => handleView(rowData)} />
            </Tooltip>
            {adminRole && (
              <Tooltip title="Delete">
                <Popconfirm title="Are You Sure You Want to Delete?" onConfirm={() => deleteCustomer(rowData.id)}>
                  <CloseOutlined />
                </Popconfirm>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
};
